import { domainConstants } from './../_constants';

export function storeDomainReducer(state = {}, action) {
  switch ( action.type ) {
    case domainConstants.SUCCESS:
      return {
        domains: {
          type: 'alert-success',
          message: action.message
        }
      }
    case domainConstants.FAILURE:
      return {
        domains: {
          type: 'alert-failure',
          message: action.failure
        }
      }
    default:
      return {
        domains: state
      }
  }
}

export function listDomainsReducer(state = {}, action) {
  switch ( action.type ) {
    case domainConstants.LIST_FILTERS_SUCCESS:
      return {
        domains: {
          type: 'alert-success',
          message: action.message
        }
      }
    case domainConstants.LIST_FILTERS_FAILURE:
      return {
        domains: {
          type: 'alert-failure',
          message: action.failure
        }
      }
    default:
      return {
        domains: state
      }
  }
}

export function changeDomainReducer(state = {}, action) {
  switch ( action.type ) {
    case domainConstants.DOMAIN_CHANGE_SUCCESS:
      return {
        type: 'DOMAIN_CHANGE_SUCCESS',
        selectedDomain: action.domain
      }
    case domainConstants.DOMAIN_CHANGE_FAILURE:
      return {
        type: 'DOMAIN_CHANGE_FAILURE',
        selectedDomain: null
      }
    default:
      return { selectedDomain: state.selectedDomain }
  }
}